import React from "react";
import TodoList from "./component/todo.list";

const Main = () => {
  return (
    <div>
      <TodoList />
    </div>
  );
};

export default Main;
